import { React } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import './Courses.scss';

export default function Courses() {
  return (
    <div className="courses-container">
      <h1 className="site_main_header">Recommended Courses</h1>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 3500 }}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        <SwiperSlide>
          <div className="course-card">
            <div className="course-image">
              <img src="https://i.imgur.com/QqKGLB5.jpg" alt="Web Development Course" />
            </div>
            <div className="course-content">
              <h2>Complete Web Development Bootcamp</h2>
              <p className="course-provider">Udemy</p>
              <p className="course-description">
                Become a full-stack web developer with just one course. HTML, CSS, Javascript, Node, React, MongoDB, and more!
              </p>
              <a href="https://www.udemy.com/course/the-complete-web-development-bootcamp/" target="_blank" rel="noopener noreferrer" className="course-link">
                Learn More
              </a>
            </div>
          </div>
        </SwiperSlide>
        
        <SwiperSlide>
          <div className="course-card">
            <div className="course-image">
              <img src="https://i.imgur.com/vLNKi8b.jpg" alt="Python Course" />
            </div>
            <div className="course-content">
              <h2>Python for Everybody</h2>
              <p className="course-provider">Coursera</p>
              <p className="course-description">
                Learn to Program and Analyze Data with Python. Develop programs to gather, clean, analyze, and visualize data.
              </p>
              <a href="https://www.coursera.org/specializations/python" target="_blank" rel="noopener noreferrer" className="course-link">
                Learn More
              </a>
            </div>
          </div>
        </SwiperSlide>
        
        <SwiperSlide>
          <div className="course-card">
            <div className="course-image">
              <img src="https://i.imgur.com/JTLcgHb.jpg" alt="JavaScript Course" />
            </div>
            <div className="course-content">
              <h2>JavaScript: Understanding the Weird Parts</h2>
              <p className="course-provider">Udemy</p>
              <p className="course-description">
                An advanced JavaScript course for everyone! Gain a deep understanding of JavaScript and how it works under the hood.
              </p>
              <a href="https://www.udemy.com/course/understand-javascript/" target="_blank" rel="noopener noreferrer" className="course-link">
                Learn More
              </a>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
